import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccessService, getKeysFromBinary } from '@common/services/access.service';
import { ObjectGroupsListItem } from '@store/state/object-groups.state';

@Injectable({
  providedIn: 'root',
})
export class ObjectsGroupsService {
  private readonly httpClient = inject(HttpClient);
  private readonly accessService = inject(AccessService);

  groupsChanged$ = new Subject<number[]>();

  list(params: any = null) {
    let httpParams = new HttpParams();

    if (params?.accountId) {
      httpParams = httpParams.set('account_id', params.accountId.toString());
    }
    return this.httpClient
      .get<ObjectGroupsListItem[]>('objects/groups/', { params: httpParams })
      .pipe(
        map((list: any) => {
          return list.map((item: any) => ({
            ...item,
            currentUserAccess:
              typeof item.currentUserAccess === 'number'
                ? getKeysFromBinary(
                    this.accessService.allAccessRights.object_groups,
                    item.currentUserAccess,
                  )
                : item.currentUserAccess,
          }));
        }),
      );
  }

  create(form: any) {
    return this.httpClient.post('objects/groups/', form);
  }

  update(form: any, objectsGroupId: number) {
    return this.httpClient.put(`objects/groups/${objectsGroupId}/`, form);
  }

  deleteObjectsGroup(objectsGroupId: number) {
    return this.httpClient.delete(`objects/groups/${objectsGroupId}`);
  }

  getById(objectsGroupId: number) {
    return this.httpClient.get(`objects/groups/${objectsGroupId}/`).pipe(
      map((item: any) => {
        return {
          ...item,
          currentUserAccess:
            typeof item.currentUserAccess === 'number'
              ? getKeysFromBinary(
                  this.accessService.allAccessRights.object_groups,
                  item.currentUserAccess,
                )
              : item.currentUserAccess,
        };
      }),
    );
  }
}
